import React from "react";
import { useSEO } from "@/hooks/useSEO";
import { Section, SectionHeading, Reveal, CTASection, Button } from "@/components/ui-bits";
import { PageHero, CapabilityCard } from "@/components/shared";
import { CAPABILITIES, BUILD_OPTIONS, AUDIENCE } from "@/lib/data";

export default function Capabilities() {
  useSEO("Manufacturing Capabilities | Wisperwick Studio",
    "Formulation, powder blending, filling and single-serve stick pack & sachet packaging — plus OEM, ODM and private label manufacturing.");
  return (
    <div>
      <PageHero eyebrow="Manufacturing capabilities" title="Built around the product."
        sub="From formulation support to finished single-serve packaging — the capabilities that take a concept to a market-ready product."
        meta={["Formulation", "Blending", "Filling", "Sachet Packaging"]} />

      <Section className="pt-0">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {CAPABILITIES.map((c, i) => <CapabilityCard key={c.title} item={c} index={i} />)}
        </div>
      </Section>

      <Section bg="var(--ws-dark)">
        <SectionHeading dark eyebrow="How you build" title="Choose how you want to build." />
        <div className="grid lg:grid-cols-3 gap-5 mt-14">
          {BUILD_OPTIONS.map((o, i) => (
            <Reveal key={o.title} delay={i * 0.08}>
              <div className="bg-ws-dark2 border border-ws-bg/10 rounded-2xl p-8 h-full flex flex-col">
                <span className="font-display text-ws-accent text-lg">0{i + 1}</span>
                <h3 className="font-display text-3xl text-ws-bg mt-4">{o.title}</h3>
                <p className="text-ws-bg mt-5 font-medium">{o.lead}</p>
                <p className="text-ws-bg/60 text-sm mt-3 leading-relaxed flex-1">{o.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </Section>

      <Section bg="var(--ws-bg2)">
        <SectionHeading eyebrow="Who we work with" title="Built for the next generation of brands." />
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-14">
          {AUDIENCE.map((a, i) => (
            <Reveal key={a.title} delay={(i % 3) * 0.07}>
              <div className="bg-ws-card border border-ws-border rounded-2xl p-8 h-full transition-colors hover:border-ws-accent">
                <h3 className="font-display text-2xl text-ws-dark leading-tight">{a.title}</h3>
                <p className="text-ws-text2 text-sm mt-3 leading-relaxed">{a.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.2}><div className="mt-12"><Button to="/request-a-quote" testid="capabilities-cta">Discuss Your Product</Button></div></Reveal>
      </Section>

      <CTASection />
    </div>
  );
}
